import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import HttpClient from 'services/HttpClient';
import { getUserToken } from 'services/utils';
import { getBaseURL } from 'services/getBaseURL';

const promissoryNoteURL = getBaseURL().wallet;
const http = new HttpClient();

const initialState = {
	loanAmount: 0,
	noteAmount: 0,
	noteLoanAmountPercent: 0,
	saftePersonalInfoStep: 1,
	promissoryNoteReview: [],
	payLink: '',
	promissoryNoteCost: 0,
	promissoryNoteData: {},
	promissoryNotePayment: {},
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
};

export const promissoryNoteAmount = createAsyncThunk('/promissoryNote/amount', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};

	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${promissoryNoteURL}/WalletRequestPromissoryNoteAmount`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const promissoryNoteConfirm = createAsyncThunk('/promissoryNote/confirm', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};
	const response = await http
		.post(`${promissoryNoteURL}/WalletRequestPromissoryNoteAmountConfirm`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const promissoryNoteDetails = createAsyncThunk('/promissoryNote/details', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const headers = {
		'Authorization': token,
	};
	const param = {
		walletRequestID: params.walletRequestID,
	};

	const response = await http
		.post(`${promissoryNoteURL}/WalletRequestPromissoryNoteDetails`, param, { headers: headers })
		.then((res) => res.data);
	return response;
});

export const promissoryNoteDetailsConfirm = createAsyncThunk(
	'/promissoryNote/detailConfirm',
	async (params, thunkAPI) => {
		const { isToastfy, ...rest } = params;

		let token = getUserToken(thunkAPI);
		const extraConfig = {
			headers: {
				'Authorization': token,
			},
		};

		const response = await http
			.post(`${promissoryNoteURL}/WalletRequestPromissoryNoteDetailsConfirm`, rest, extraConfig, isToastfy)
			.then((res) => res.data);
		return response;
	},
);
export const promissoryNotePaymentStatus = createAsyncThunk(
	'/promissoryNote/payment',
	async (params, thunkAPI) => {
		let token = getUserToken(thunkAPI);
		const headers = {
			'Authorization': token,
			'Content-Type': 'application/json',
			'Content-Disposition': 'attachment',
		};
		const param = {
			walletRequestID: params.walletRequestID,
		};
		const response = await http
			.post(`${promissoryNoteURL}/WalletRequestPromissoryNotePaymentStatus`, param, {
				headers: headers,
			})
			.then((res) => res.data);
		return response;
	},
);
const promissoryNote = createSlice({
	name: 'promissoryNote',
	initialState,
	reducers: {
		setPersonalInfoStep(state, action) {
			state.saftePersonalInfoStep = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(promissoryNoteAmount.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(promissoryNoteAmount.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.loanAmount = Content?.loanAmount;
					state.noteAmount = Content?.PromissoryNoteAmount;
					state.noteLoanAmountPercent = Content?.PromissoryNoteloanAmountPercent;
				}
				state.isLoading.skeleton = false;
			})
			.addCase(promissoryNoteAmount.rejected, (state) => {
				state.isLoading.skeleton = false;
			})
			.addCase(promissoryNoteConfirm.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(promissoryNoteConfirm.fulfilled, (state) => {
				state.isLoading.button = false;
			})
			.addCase(promissoryNoteConfirm.rejected, (state) => {
				state.isLoading.button = false;
			})

			.addCase(promissoryNoteDetails.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(promissoryNoteDetails.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				state.isLoading.skeleton = false;

				if (Success) {
					state.promissoryNoteReview = Content;
					state.promissoryNoteCost = Content?.PromissoryNotesCost;
				}
			})
			.addCase(promissoryNoteDetails.rejected, (state) => {
				state.isLoading.skeleton = false;
			})

			.addCase(promissoryNoteDetailsConfirm.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(promissoryNoteDetailsConfirm.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					window.location.href = Content.PaymentGatewayLink;
				}

				state.isLoading.button = false;
			})
			.addCase(promissoryNoteDetailsConfirm.rejected, (state) => {
				state.isLoading.button = false;
			})

			.addCase(promissoryNotePaymentStatus.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(promissoryNotePaymentStatus.fulfilled, (state, action) => {
				const { Content, Success } = action.payload;
				if (Success) {
					state.promissoryNoteData = Content;
					state.promissoryNotePayment = Content;
				}
				state.isLoading.skeleton = false;
			})
			.addCase(promissoryNotePaymentStatus.rejected, (state) => {
				state.isLoading.skeleton = false;
			});
	},
});
export const { setPersonalInfoStep } = promissoryNote.actions;
export default promissoryNote.reducer;
